import Vue from 'vue'
import Router from 'vue-router'
import HomeView from '@/components/HomeView'
// import Login from '@/components/Login'
import Auth from '@/components/Auth'
import SignUp from '@/components/SignUp'
import ViewBill from '@/components/ViewBill'
import NewBill from '@/components/NewBill'
import Landing from '@/components/Landing'
import firebase from 'firebase/app'
import 'firebase/auth'
Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Auth
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/home',
      name: 'home',
      component: Landing,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bills',
      name: 'bills',
      component: HomeView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add',
      name: 'new-bill',
      component: NewBill,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: ':company/:bill/:success?',
      name: 'view-bill',
      component: ViewBill,
      meta: {
        requiresAuth: true
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  // console.log(firebase.auth().currentUser)
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // console.log(to)
  // console.log(from)
  // console.log(currentUser)
  // console.log(requiresAuth)
  // console.log('requiresAuth && !currentUser : ' + (requiresAuth && (!currentUser)))
  // console.log('!requiresAuth && currentUser : ' + ((!requiresAuth) && currentUser))
  if (requiresAuth && (!currentUser)) {
    next('login')
  } else if ((!requiresAuth) && currentUser) {
    next('home')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js